import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type MbmButtonVariant = 'primary' | 'outline' | 'dark';
export type MbmButtonSize = 'default' | 'small';

@Component({
  selector: 'mbm-button',
  imports: [TranslateModule],
  templateUrl: './mbm-button.component.html',
  styleUrl: './mbm-button.component.scss',
  host: { '[class.mbm-button-inline]': '!fullWidth()' },
})
export class MbmButtonComponent {
  readonly textKey = input<string>();
  readonly text = input<string>();
  /** Optional second line in normal, smaller type; makes the button taller. */
  readonly subtextKey = input<string>();
  readonly variant = input<MbmButtonVariant>('primary');
  readonly size = input<MbmButtonSize>('default');
  readonly fullWidth = input<boolean>(true);
  readonly disabled = input<boolean>(false);
  readonly iconSrc = input<string | null>(null);
  readonly iconPosition = input<'start' | 'end'>('start');
  readonly iconAltKey = input<string | null>(null);

  readonly buttonClick = output<void>();

  protected onButtonClick(): void {
    this.buttonClick.emit();
  }
}
